import request from "@/utils/request";

// 致闲致忙
export const workerSipState = (param) => request.post('/web2/worker/workerSipState', param);
// 自动应答
export const workerAnswerStatus = (param) => request.post('/web2/worker/workerAnswerStatus', param);